export const defaultStyle = {
  profileSectionWrapper:"profileSectionWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  profileSection:"total-mange-team-area flex flex-wrap text-center pt-50 pb-50 md:pb-70 px-[35px] md:px-15 mx-[-25px] md:mx-[-50px] ",
  profileWrapper:"w-1/2 md:w-1/3 lg:w-1/4 px-25 mb-80",
  profileImg:"absolute z-[1] w-[50%]",
  profileName:"text-[16px] md:text-[28px] font-Bold tracking-normal leading-[16px] md:leading-[28px] px-10 font-MDLZBiteType",
  profileDesignation:"text-[12px] md:text-[18px] tracking-[0.45px] leading-[1.5] px-10",
  profileShapePic:"profile-shape-picture-area flex items-center justify-center w-full relative mb-[45px] text-center",
  profileCardWrapper:'profileCardWrapper w-full',
  profileCardWrapperLink:'profileCardWrapperLink w-full',    
}
